document.addEventListener('DOMContentLoaded', () => {
  const currentHostname = window.location.hostname;

  document.querySelectorAll('a[href]').forEach(link => {
    try {
      const linkHostname = new URL(link.href).hostname;

      if (linkHostname !== currentHostname) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    } catch (error) {

    }
  });
});